<template>
	<li class="item">
        <!-- 当不能预约的时候加上类  disabled -->
        <div class="izk-course-info">
            <span class="ico-course-new ti" v-if="course.is_new">new</span>
            <router-link class="hbox info-con" :to="detailLink">
                <div class="pic">
                    <img :src="course.experience_url" alt=""/>
                </div>
                <div class="flex con">
                    <h4 class="title te2">{{course.title}}</h4>
                    <p class="info"><i class="ico-course-time">{{course.course_begin_datetime}}-{{course.course_end_datetime}}</i></p>
                    <p class="info"><i class="ico-course-place">{{course.school_info.name}}</i></p>
                </div>
            </router-link>
            <div class="tagbox cbox">
                <span class="times">{{course.totalNum}}次课</span>
                <!-- <span class="num">{{course.buyNum}}人已预约</span> -->
                <span class="num" v-if="course.remaining_quotas">{{course.remaining_quotas}}</span>
                <!-- <span class="heat" v-if="course.is_hot">热报中</span> -->
            </div>
            <div class="reserve cbox">
                <div class="flex teacher cbox">
                    <img :src="course.teacher_img" :alt="course.teacher_img" v-if="course.teacher_img" />
                        <h5 class="name">{{course.teacher_name}}</h5>
                </div>
                    <a href="javascript:void(0)" class="g-btn3">立即预约</a>
            </div>
        </div>
    </li>
</template>
<script>
	export default{
	  name: 'EightExperience',
	  props: {
	    course: {
	      type: Object,
	      default: {},
	      required: true
	    }
	  },
	  data(){
	    return {

	    }
	  },
  computed: {
    detailLink(){
      let course = this.course;
      let route = this.$route;

      return {
        path: `/${  route.params.city  }/detail/${  course.course_id}`,
        query: {
          grade: course.grade,
          type: course.type,
          sub_type: course.sub_type,
          school_id: course.school_info.id,
          category: "10002",
          course_type: 103,
          routeName: 'group'
        }
      }
    }
  },
	  methods: {
    order(){
      this.$emit('order', this.course);
    }
	  },
	  created(){

	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/eight/public/Experience.vue